export const PersonalConstant = {
  FIRST_NAME: 'firstName',
  MIDDLE_NAME: 'middleName',
  LAST_NAME: 'lastName',
  DOB: 'dob',
  MARITAL_STATUS: 'maritalStatus',
  NO_OF_DEPENDANT: 'noOfDependant',
  TITLE: 'title',
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year',
};

export const EmploymentConstant = {
  EMP_STATUS: 'employmentStatus',
  OCCUPATION: 'occupation',
};

export const IncomeExpenseConstant = {
  ANNUAL_INCOME: 'annualIncome',
  MONTHLY_INCOME: 'monthlyIncome',
  MORTGAGE_RENT: 'mortgageRent',
  OTHER_PAY: 'otherPay',
};

export const AboutAccountConstant = {
  SOLE: 'Sole',
  JOINT: 'Joint',
};

export const TaskConstant = {
  TASK_01: 'TSK-01',
  TASK_02: 'TSK-02',
  TASK_03: 'TSK-03',
  TASK_04: 'TSK-04',
  TASK_05: 'TSK-05',
  TASK_06: 'TSK-06',
  TASK_07: 'TSK-07',
};

export const AddressConstant = {
  POST_CODE: 'postCode',
  SELECTED_ADDRESS_ID: 'selectedAddressId',
  CURRENT_ADDRESS_DATE: 'currentAddressDate',
  MONTH: 'month',
  YEAR: 'year',
  PREVIOUS_ADDRESS_DATE: 'previousAddressDate',
  INTERNATIONAL_ADDRESS_EMPTY: 'InternationalAddressEmpty',
  PREVIOUS_ADDRESS_IN_UK: 'radioIsAddressUK',
  INVALID_FIELD: 'inValidField',
  GREAT_BRITAIN: 'GB',
};

export const brands = {
  CB: 'cb',
  YB: 'yb',
  VM: 'vm'
};

export const FieldName = {
  STOCKS_SHARES_ISA: 'STOCKS_SHARES_ISA',
  TRANSFER_OPTIONS: 'TRANSFER_OPTIONS',
  ACCOUNT_NUMBER: 'ACCOUNT_NUMBER',
  SORT_CODE: 'SORT_CODE',
  ACCOUNT_REFERENCE: 'ACCOUNT_REFERENCE',
  EXISTING_ISA_OPTIONS: 'EXISTING_ISA_OPTIONS',
  ISA_PROVIDER: "ISA_PROVIDER",
  TRANSFER_PERIOD_OPTIONS: "TRANSFER_PERIOD_OPTIONS",
  AMOUNT: "AMOUNT"
}

export const Type = {
  NUMBER: "number",
  TEXT: "text"
}

export const Currency = {
  POUND : "£"
}

export const TransferOptionsConstants = {
  ACCOUNT_NUMBER_SORT_CODE: "ACCOUNT_NUMBER_SORT_CODE",
  ACCOUNT_REFERENCE: "ACCOUNT_REFERENCE",
  CHOSEN_AMOUNT: "Chosen amount"
}

